import { Typography } from '@mui/material';
import { ListItemButton, ListItemAvatar, ListItemText, ListItemSecondaryAction } from '@mui/material';
import moment from 'moment';
import { FC } from 'react';
import { NotificationTypes } from 'types/notification';
import { generateTimeFormat } from 'utils/date';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
interface Props {
  data: NotificationTypes;
  onClickNotification: (notificationId: number) => void;
}

const NotificationItem: FC<Props> = ({ data, onClickNotification }) => {
  return (
    <ListItemButton
      className={`notificaiton-item ${data.status.toUpperCase()}`}
      {...(data.status === 'Unread' ? { onClick: () => onClickNotification(data.notificationID) } : {})}
    >
      <ListItemAvatar
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'left',
          width: 56,
          height: 56
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 45 }} />
        {/* <Avatar type="filled">
          <GifOutlined />
        </Avatar> */}
      </ListItemAvatar>
      <ListItemText
        primary={<Typography variant="h6">{data.notificationMessage}</Typography>}
        secondary={moment(data.notificationTime).fromNow()}
      />
      <ListItemSecondaryAction>
        <Typography variant="caption" noWrap>
          {generateTimeFormat(data.notificationTime)}
        </Typography>
      </ListItemSecondaryAction>
    </ListItemButton>
  );
};

export default NotificationItem;
